/**
 * Group Selector Component
 *
 * Matches original HTML structure: #persistent-group-selector > .group-tabs > .group-tab
 */

import {
  groups,
  selectedGroupId,
  selectGroup,
  isLoading,
} from '@/stores/groups';
import { isAuthenticated } from '@/stores/auth';

export function GroupSelector() {
  // Don't show if not authenticated
  if (!isAuthenticated.value) {
    return null;
  }

  return (
    <div
      class="group-selector-container"
      id="persistent-group-selector"
      style={{ display: isAuthenticated.value ? 'block' : 'none' }}
    >
      <div class="group-tabs" id="group-tabs">
        {isLoading.value ? (
          // Loading state
          <>
            <div class="group-tab">Loading...</div>
          </>
        ) : groups.value.length === 0 ? (
          // Empty state
          <div class="group-tab">No pods yet</div>
        ) : (
          // Group tabs
          groups.value.map((group) => (
            <div
              key={group.id}
              class={`group-tab ${selectedGroupId.value === group.id ? 'active' : ''}`}
              onClick={() => selectGroup(group.id)}
            >
              {group.name}
              {/* Status indicator for active period */}
              {group.periods?.currentPhase === 'voting' && (
                <span class="status-indicator voting"></span>
              )}
              {group.periods?.currentPhase === 'submission' && (
                <span class="status-indicator submission"></span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
